<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 10:47:12
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2026-04-01 09:58:05
--> 
<template>
  <div>
    <div class="drop_area">
      <div class="progress" v-if="uploading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="disabled" class="disabledview"></div>
      <mrc_ess_fileInput
        :accept="accept"
        :multiple="multiple"
        :uploadFileType="uploadFileType"
        @changeimgSrc="changeimgSrc"
      >
      </mrc_ess_fileInput>
      <v-icon
        class="material-icons mb-5"
        style="color: #e0e0e0; font-size: 71px"
      >
        cloud_upload
      </v-icon>
      nnn
      <span>
        <v-btn
          rounded
          depressed
          color="#C6DBFD"
          class="text-capitalize primary--text"
          height="40"
          :style="{
            padding: '0px 110px',
            'font-size': '14px',
            'font-weight': 600,
            color: $vuetify.theme.defaults.light.primary,
          }"
          dark
          >{{ $t("label_browse") }}</v-btn
        >
      </span>
      <span style="color: #a4a4a4" class="mt-4">
        *{{ $t("label_support") }} {{ fileTypeLabel }}
      </span>
    
    </div>
   
  </div>
</template>

<script>
/**
 *  uploadFileType   验证规则 正则表达式
 *  accept   input接受文件规则
 *  file 返回的文件对象
 *  @downloadTemplate 下载模板点击事件
 */
export default {
  components: {},
  props: {
    fileTypeLabel: {
      type: String,
      default: ".xls / .xlsx / .csv",
    },
    uploading: {
      //加载状态
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadFileType: {
      // default: () => { return /\.(xls|xlsx|csv)$/ }
      default: () => {
        return /\./;
      },
    },
    accept: {
      type: String,
      default: "*",
      // default: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv'
    },
    file: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "file",
    event: "changeFile",
  },
  filters: {
    unitConversion(v) {
      return (Number(v) / 1024 / 1024).toFixed(2) + "M";
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {},
  methods: {
   
    downloadTemplate() {
      this.$emit("downloadTemplate");
    },
    changeimgSrc(v) {
      if (this.multiple) {
        this.$emit("changeFile", v);
      } else {
        this.$emit("changeFile", v[0]);
      }
    },
  },
};
</script>

<style scoped>
.progress {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.disabledview {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.drop_area {
  overflow: hidden !important;
  position: relative;
  background-color: #ffffff;
  border: 4px dashed #e0e0e0;
  width: 100%;
  height: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 350px;
  justify-content: center;
}
.bigbox {
  position: relative;
  background-color: #ffffff;
  width: 100%;
  min-height: 150px;
  border: 4px solid #e0e0e0;
  padding-left: 8px;
  display: flex;
  justify-items: center;
  align-items: center;
  overflow: hidden;
}
</style>
